import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URLS } from 'src/app/constants/URLS';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { Subscription } from 'rxjs';
import { CategoryService } from 'src/app/_service/category.service';
import { DownloadProgressService } from 'src/app/_service/download-progress.service';
import { AppComponent } from 'src/app/app.component';
import { IndexedDbServiceService } from 'src/app/_service/indexed-db-service.service';
import { ReportModalComponent } from '../../sharedComponents/report-modal/report-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { ShareModalComponent } from '../../sharedComponents/share-modal/share-modal.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/_service/api.service';
import { VidsPlayerComponent } from '../../sharedComponents/vids-player/vids-player.component';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { environment } from 'src/environments/environment';
import { getAppBasePath } from 'src/app/utils/share-link.utils';
import { getVideoStreamFile } from 'src/app/utils/media-url.utils';

declare let shaka: any;
declare let window: any;

@Component({
  selector: 'app-cc-prime-player',
  templateUrl: './cc-prime-player.component.html',
  styleUrls: ['./cc-prime-player.component.css']
})
export class CcPrimePlayerComponent implements OnInit, OnDestroy {
  @ViewChild('customPlayer', { static: false }) customPlayerRef!: VidsPlayerComponent;

  private routeSubscription: Subscription | undefined;
  videoElement: HTMLVideoElement | undefined;
  videoContainerElement: HTMLDivElement | undefined;
  player: any;
  userId: Number;
  screenName: string;
  channelId: number;
  vidLibId: number;
  videoType: String;
  currentVideoRunningTime: number = 0;
  videoDuration: number = 0;
  videoFileSize: number = 0;
  mediaUrl: any; 
  channelUrl: any = URLS.channelUrl;
  imgUrl:string = URLS.imgUrl;
  postVideos: any = URLS.mediaUrl; 
  videos: any;
  videoDetails: any;
  firstIndex: number = 0;
  lastIndex: number = 9;
  categoryId: string;
  isMiniPlayer: boolean = false;
  vidLikes: number;
  vidDislikes: number;
  isLiked: boolean;
  isDisliked: boolean;
  showOptionsDropdown: boolean = false;
  isUserFollowed: boolean;
  channelFollowers: string;
  token: any;
  isLoading: boolean = false;
  ccPrimeWatchlist: any;
  private ui: any;
  currentWatchlistIndex: number = 0;
  currentDownloadlistIndex: number = 0;
  watchList: any[] = [];
  downloadList: any[] = [];
  isWatchlistShown: boolean = false;
  isDownloadlistShown: boolean = false;
  currentVideo: any = null;
  progressBarId: any;
  loaderShowHide: boolean;
  downloadingToast: boolean;
  offlineUri: any;
  offlineVideoId: any;
  appComponent: any;

  nextVideo: any;
  delayTimer: number = 5;
  isNextVideoPreview: boolean = false;
  countdownInterval: any;
  nextVideoTitle: string = '';
  showFullDescription: boolean = false;
  showWatchList: boolean = false;
  isAutoplayEnabled: boolean = true;
  isLoopEnabled: boolean = false;
  isShuffleEnabled: boolean = false;
  
  originalWatchList: any[] = [];
  shuffledWatchList: any[] = [];

  loadingMoreLike:boolean = false;
  loadingVideoDetails:boolean = false;

  constructor(  
    private route: ActivatedRoute,
    private mycontentService: MycontentserviceService,
    private http: HttpClient,
    private authService: AuthenticateserviceService,
    private router: Router,
    private categService: CategoryService,
    private watchlistService: MycontentserviceService,
    private downloadProgressService: DownloadProgressService,
    private indexedDBService: IndexedDbServiceService,
    private dialog: MatDialog,
    private toastrService: CustomControlsService,
    private sanitizer: DomSanitizer,
    private apiService: ApiService,
    private whitelabelService: WhiteLabelService,
    private axinomService: AxinomDrmService
  ) {
    this.downloadProgressService.downloadCompletedEvent.subscribe((event) => {
      if (this.videoDetails) {
        this.videoDetails.isDownloaded = true;
      }
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.loadUserPreferences();
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleRouteChange();
      }
    });
    this.handleRouteChange();
    this.appComponent = new AppComponent(this.downloadProgressService, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private cleanup(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (this.currentVideoRunningTime > 0 && this.videoDuration > 0) {
      this.updateWatchHistory();
    }
    if (this.player) {
      try {
        this.player.destroy().then(() => {
          this.player = null;
        }).catch(error => {
          console.warn('Error destroying player:', error);
          this.player = null;
        });
      } catch (error) {
        console.warn('Error destroying player:', error);
        this.player = null;
      }
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
      this.routeSubscription = undefined;
    }
    this.saveUserPreferences();
  }

  private handleRouteChange(): void {
    this.route.queryParams.subscribe(params => {
      const newVidLibId = params['ref'];
      const newOfflineVideoId = params['offlineUri'];
      if (newVidLibId !== this.vidLibId || newOfflineVideoId !== this.offlineVideoId) {
        this.loadVideoData(params);
      }
    });
  }

  private async loadVideoData(params: any): Promise<void> {
    try {
      this.isLoading = true;
      this.isNextVideoPreview = false;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.vidLibId = params['ref'];
      this.userId = Number(localStorage.getItem('userId'));
      this.screenName = localStorage.getItem('screenName') || 'User';
      this.offlineUri = params['offlineUri'];
      if (this.offlineUri) {
        this.mediaUrl = this.offlineUri;
      } else {
        this.mediaUrl = this.postVideos + getVideoStreamFile(this.vidLibId);
      }
      await this.handleListParameters(params);
      if (this.vidLibId || this.offlineUri) {
        await Promise.all([
          this.getVideoDetails(this.vidLibId),
          this.getUserLikedVideos(this.vidLibId)
        ]);
        await this.initPlayer();
      }
      this.isLoading = false;
    } catch (error) {
      console.error('Error loading video data:', error);
      this.isLoading = false;
    }
  }

  private async handleListParameters(params: any): Promise<void> {
    if (params.hasOwnProperty('list')) {
      const list = params['list'];
      const index = parseInt(params['index']) || 0;
      if (list === 'wl') {
        await this.getUserWatchList();
        this.isWatchlistShown = true;
        this.isDownloadlistShown = false;
      } else if (list === 'dl') {
        await this.prepareDownloadData();
        this.isDownloadlistShown = true;
        this.isWatchlistShown = false;
      }
    } else {
      this.isWatchlistShown = false;
      this.isDownloadlistShown = false;
      this.currentWatchlistIndex = 0;
    }
  }

  sanitizeBlobUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  async prepareDownloadData() {
    this.downloadList = [];
    const content = await this.getStorageContentWithRetry();
    if (!content || content.length === 0) {
      console.warn('No content found in storage.');
      return;
    }
    for (let videoEle of content) {
      if (videoEle.appMetadata?.thumbnail instanceof Blob) {
        videoEle.appMetadata.downloadBlob = URL.createObjectURL(videoEle.appMetadata.thumbnail);
      } else {
        videoEle.downloadBlob = './assets/img/thumbnail.png';
      }
      if (!videoEle.thumbnailUrl) {
        videoEle.thumbnailUrl = videoEle.downloadBlob;
      }
      if (videoEle.appMetadata) {
        videoEle.vidLibId = videoEle.appMetadata.vidLibId;
        videoEle = { ...videoEle, ...videoEle.appMetadata };
      }
      if (videoEle.appMetadata?.videoCategory === 'ccPrime') {
        this.downloadList.push(videoEle);
      }
    }
    if (this.downloadList?.length > 0) {
      this.updateCurrentAndNextVideo();
    }
  }

  private updateCurrentAndNextVideo(): void {
    const currentList = this.isDownloadlistShown ? this.downloadList : this.getActiveWatchList();
    if (currentList && currentList.length > 0) {
      const currentVideoIndex = currentList.findIndex(video => 
        video.vidLibId == this.vidLibId || video.vidLibId == this.offlineVideoId
      );
      if (currentVideoIndex >= 0) {
        this.currentVideo = currentList[currentVideoIndex];
        this.currentWatchlistIndex = currentVideoIndex + 1; 
      } else {
        const urlIndex = Math.min(this.currentWatchlistIndex - 1, currentList.length - 1);
        this.currentVideo = currentList[urlIndex] || currentList[0];
        this.currentWatchlistIndex = urlIndex + 1;
      }
      let nextIndex = this.currentWatchlistIndex;
      if (nextIndex >= currentList.length) {
        if (this.isLoopEnabled) {
          nextIndex = 0; 
        } else {
          this.nextVideo = null;
          this.nextVideoTitle = 'End of queue';
          return;
        }
      }
      this.nextVideo = currentList[nextIndex];
      this.nextVideoTitle = this.nextVideo?.title || 'No next video';
    } else {
      this.currentVideo = null;
      this.nextVideo = null;
      this.nextVideoTitle = 'No videos in queue';
    }
  }

  private getActiveWatchList(): any[] {
    if (this.isShuffleEnabled) {
      return this.shuffledWatchList.length > 0 ? this.shuffledWatchList : this.watchList;
    }
    return this.watchList;
  }

  async getStorageContentWithRetry(retries = 3, delay = 500): Promise<any[]> {
    let content;
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        content = await window.storage?.list();
        if (content && content.length > 0) {
          return content;
        }
      } catch (error) {
        console.error('Error fetching from storage on attempt', attempt + 1, error);
      }
      await this.delay(delay);
    }
    return [];
  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async getVideoOfflineDetails(mediaUrl: string) {
    try {
      const downloadResult = await this.listContent();
      let matchedVideoDetails: any = null;
      for (const dlitem of downloadResult) {
        if (dlitem.originalManifestUri === mediaUrl) {
          matchedVideoDetails = dlitem.appMetadata;
          break;
        }
      }
      if (matchedVideoDetails) {
        this.videoDetails = matchedVideoDetails;
      }
    } catch (error) {
      console.error('Error mapping download content:', error);
    }
  }

  private async initPlayer() {
    if (!this.customPlayerRef) {
      setTimeout(() => this.initPlayer(), 100);
      return;
    }

    try {
      if (this.player) {
        try {
          await this.player.destroy();
          this.player = null;
        } catch (error) {
          console.warn('Error destroying previous player:', error);
        }
      }

      shaka.polyfill.installAll();
      if (shaka.Player.isBrowserSupported()) {
        await this.indexedDBService.ensureDbInitialized();
        const token: string = localStorage.getItem('token') || '';
        const drmServersConfig = {
          'com.widevine.alpha': this.axinomService.getWidevineUrl()
        };
        const drmConfig = {
          servers: drmServersConfig,
          advanced: {
            'com.widevine.alpha': {
              persistentStateRequired: true,
            }
          },
        };
        await this.customPlayerRef.initShakaPlayer(this.mediaUrl, drmConfig);
        this.videoElement = this.customPlayerRef.videoElement;
        this.player = this.customPlayerRef.player;
        if (this.videoDetails?.secondsWatched && this.videoDetails?.secondsWatched > 0) {
          this.videoElement.currentTime = this.videoDetails?.secondsWatched;
        }
        try {
          await this.videoElement.play();
        } catch (playError) {
          console.warn('Auto-play failed:', playError);
        }
      }
    } catch (error) {
      console.error('Player initialization error:', error);
      this.isLoading = false;
    }
  }

  private loadVideo() {
    if (this.customPlayerRef && this.customPlayerRef.player) {
      this.customPlayerRef.player.load(this.mediaUrl)
        .then(() => {
          setTimeout(() => {
            if (this.customPlayerRef.videoElement) {
              this.customPlayerRef.videoElement.play().catch(error => {
                console.warn('Play failed after load:', error);
              });
            }
          }, 100);
        })
        .catch((error: any) => {
          console.error('Error loading video:', error);
          this.initPlayer();
        });
    } else {
      this.initPlayer();
    }
  }

  onTimeUpdate(currentTime: number) {
    this.currentVideoRunningTime = currentTime;
  }

  goToVideo(videoId: any, channelId: string, videoType: string): void {
    this.watchList = [];
    this.isWatchlistShown = false;
    this.isDownloadlistShown = false;
    const route = this.whitelabelService.getPrefixedRoute('watch');
    this.router.navigate([route], { 
      queryParams: { ref: videoId, channelId, videoType } 
    });
  }

  goToWatchlistVideo(video: any, videoIndex: number): void {
    console.log('Navigating to watchlist video:', video.title, 'Index:', videoIndex);
    this.isNextVideoPreview = false;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    if (this.currentVideoRunningTime > 0 && this.videoDuration > 0) {
      this.updateWatchHistory();
    }
    if (this.isDownloadlistShown) {
      const route = this.whitelabelService.getPrefixedRoute('watch');
      this.router.navigate([route], {
        queryParams: {
          offlineUri: video.offlineUri,
          offlineVideoId: video.vidLibId,
          list: 'dl',
          index: videoIndex
        }
      });
    } else {
      const route = this.whitelabelService.getPrefixedRoute('watch');
      this.router.navigate([route], {
        queryParams: {
          ref: video.vidLibId,
          channelId: video.channelId,
          videoType: video.videoType,
          list: 'wl',
          index: videoIndex
        }
      });
    }
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  onVideoEnded() {
    console.log('Video ended, autoplay enabled:', this.isAutoplayEnabled);
    if (!this.isAutoplayEnabled) {
      return;
    }
    const currentList = this.isDownloadlistShown ? this.downloadList : this.getActiveWatchList();
    if (!currentList || currentList.length === 0) {
      console.log('No videos in queue');
      return;
    }
    let nextIndex = this.currentWatchlistIndex;
    if (nextIndex >= currentList.length) {
      if (this.isLoopEnabled) {
        nextIndex = 0;
        console.log('Looping back to first video');
      } else {
        console.log('End of queue reached, no loop');
        return;
      }
    }
    this.nextVideo = currentList[nextIndex];
    if (this.nextVideo) {
      console.log('Playing next video:', this.nextVideo.title);
      this.isNextVideoPreview = true;
      this.delayTimer = 5;
      this.countdownInterval = setInterval(() => {
        this.delayTimer--;
        console.log('Countdown:', this.delayTimer);
        if (this.delayTimer <= 0) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
          setTimeout(() => {
            this.goToWatchlistVideo(this.nextVideo, nextIndex);
          }, 500);
        }
      }, 1000);
    } else {
      console.log('No next video found');
    }
  }

  cancelAutoplay(): void {
    this.isNextVideoPreview = false;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  toggleAutoplay(): void {
    this.isAutoplayEnabled = !this.isAutoplayEnabled;
    this.saveUserPreferences();
    this.showSuccess(`Autoplay ${this.isAutoplayEnabled ? 'enabled' : 'disabled'}`);
  }

  toggleLoop(): void {
    this.isLoopEnabled = !this.isLoopEnabled;
    this.saveUserPreferences();
    this.showSuccess(`Loop ${this.isLoopEnabled ? 'enabled' : 'disabled'}`);
  }

  toggleShuffle(): void {
    this.isShuffleEnabled = !this.isShuffleEnabled;
    if (this.isShuffleEnabled) {
      this.shuffleWatchList();
    }
    this.updateCurrentAndNextVideo();
    this.saveUserPreferences();
    this.showSuccess(`Shuffle ${this.isShuffleEnabled ? 'enabled' : 'disabled'}`);
  }

  private shuffleWatchList(): void {
    this.shuffledWatchList = [...this.watchList];
    for (let i = this.shuffledWatchList.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.shuffledWatchList[i], this.shuffledWatchList[j]] = [this.shuffledWatchList[j], this.shuffledWatchList[i]];
    }
  }

  private loadUserPreferences(): void {
    const prefs = localStorage.getItem('videoPlayerPreferences');
    if (prefs) {
      const preferences = JSON.parse(prefs);
      this.isAutoplayEnabled = preferences.autoplay !== false; // Default true
      this.isLoopEnabled = preferences.loop || false;
      this.isShuffleEnabled = preferences.shuffle || false;
    }
  }

  private saveUserPreferences(): void {
    const preferences = {
      autoplay: this.isAutoplayEnabled,
      loop: this.isLoopEnabled,
      shuffle: this.isShuffleEnabled
    };
    localStorage.setItem('videoPlayerPreferences', JSON.stringify(preferences));
  }

  async getVideoDetails(vidLibId: number) {
    this.loadingVideoDetails = true;

    try {
      const result: any = await this.apiService.post(`${URLS.getCcPrimeVideoLibrary}?videoType=premium&vidLibList=${vidLibId}`, {}).toPromise();
      if (result.data && result.data.length > 0) {
        const firstVideo = result.data[0];
        this.categoryId = firstVideo.categoryV2;
        this.vidLikes = firstVideo.vidLike;
        this.vidDislikes = firstVideo.vidDislike;
        this.videoDetails = this.mycontentService.transformVideoData(firstVideo, 'ccPrime');
        this.videoFileSize = this.videoDetails.videoFileSize;
        this.videoDuration = this.videoDetails.durationInSeconds;
        this.videoType = this.videoDetails.videoType;
        this.channelId = this.videoDetails.channelId;
        console.log(this.videoDetails);
        if (firstVideo.categoryV2) {
          this.getMyFeedData(firstVideo.categoryV2);
        }
        this.watchlistService.isInWatchlist(result.data[0].vidLibId).subscribe(isInWatchlist => {
          this.videoDetails.isInWatchList = isInWatchlist;
        });
        if (!this.offlineUri) {
          this.mediaUrl = this.postVideos + getVideoStreamFile(this.videoDetails);
        }
        this.videoDetails.isDownloaded = await this.isDownloadFIleExist(this.postVideos + getVideoStreamFile(this.videoDetails));
        if (this.channelId) {
          this.isUserFollowed = this.categService.isUserFollowingChannel(this.channelId);
          this.channelFollowers = this.categService.getChannelFollowers(this.channelId);
        }
      }
      this.loadingVideoDetails = false;
    } catch (error) {
      console.error("Error fetching video details:", error);
      this.loadingVideoDetails = false;
    }
  }

  async getUserWatchList() {
    try {
      const wList = await this.mycontentService.getWatchListOfUser(this.userId).toPromise();
      if (wList && wList.length > 0) {
        wList.forEach(item => {
          this.mycontentService.transformData(item);
        });
        this.originalWatchList = wList.filter(item => item.content_sub_type === '1');
        this.watchList = [...this.originalWatchList];
        if (this.isShuffleEnabled) {
          this.shuffleWatchList();
        }
        this.updateCurrentAndNextVideo();
      } else {
        this.originalWatchList = [];
        this.watchList = [];
        this.currentVideo = null;
        this.nextVideo = null;
        this.nextVideoTitle = 'No videos in queue';
      }
    } catch (error) {
      console.error('Error fetching watchlist:', error);
      this.originalWatchList = [];
      this.watchList = [];
    }
  }

  isCurrentVideoPlaying(video: any): boolean {
    if (!video) {
      return false;
    }
    if (this.isWatchlistShown || this.isDownloadlistShown) {
      const currentList = this.isDownloadlistShown ? this.downloadList : this.getActiveWatchList();
      const videoIndex = currentList.findIndex(v => v.vidLibId === video.vidLibId);
      return videoIndex === (this.currentWatchlistIndex - 1);
    }
    const currentId = this.vidLibId || this.offlineVideoId;
    const videoId = video.vidLibId || video.offlineVideoId;
    return currentId && videoId && (currentId == videoId);
  }

  getMyFeedData(category_id: string) {
    this.loadingMoreLike = true;
    this.apiService.post(`${URLS.getCcPrimeVideoCategory}?start_index=${this.firstIndex}&last_index=${this.lastIndex}&video_type=premium&category_id=${category_id}`, {}).subscribe((result: any) => {
      this.videos = result.data.map((item) => {
        return {
          ...item,
          modifiedDate: this.authService.calculateModifiedDate(item.uploadedTime),
          channel_desc: item.properties.find(p => p.name === 'channel_desc')?.value || '',
        }
      });
      this.mapWatchContent();
      this.loadingMoreLike = false;
    }, (error) => {
      this.loadingMoreLike = false;
      console.error('Error fetching feed data:', error);
    });
  }

  mapWatchContent() {
    const userId = localStorage.getItem('userId');
    this.mycontentService.getWatchListOfUser(userId).subscribe(watchResult => {
      this.videos.forEach((section) => {
        section.isInWatchList = false;
        watchResult.forEach((wList) => {
          if (section.vidLibId == wList.vidLibId) {
            section.isInWatchList = true;
          }
        });
      });
    });
  }

  toggleMiniPlayer() {
    this.isMiniPlayer = !this.isMiniPlayer;
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyBoardEvent(event: any) {
    if (event.key === 'i' || event.key === 'I') {
      this.toggleMiniPlayer();
    }
  }

  loading = false;

  getUserLikedVideos(vidLibId: any): void {
    this.loading = true;
    this.apiService.post(`${URLS.userLikedVideos}`, {}).subscribe({
      next: (result: any) => {
        this.isLiked = result.user_likes.includes(parseInt(vidLibId));
        this.isDisliked = result.user_dislikes.includes(parseInt(vidLibId));
      },
      error: (err) => {
        console.error('Failed to fetch user liked videos:', err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  likeDislikeContent(status: string) {
    this.apiService.post(`${URLS.setUserStatus}?vid_lib_id=${this.vidLibId}&tqr_user_id=${this.userId}&status=${status}`, {}).subscribe((result: any) => {
      this.vidLikes = result.total_like;
      this.vidDislikes = result.total_dislike;
      this.getUserLikedVideos(this.vidLibId);
    });
  }

  followUnfollowChannel(channelId: any) {
    this.apiService.post(`${URLS.followTimeLineUser}?tqr_user_id=${this.userId}&channel_id=${channelId}&mute=${this.isUserFollowed}`, {}).subscribe((result: any) => {
      if (result.status == '0') {
        this.isUserFollowed = !this.isUserFollowed;
        this.categService.getChannelInfoByUserId().subscribe((result) => {
          localStorage.removeItem('channelData');
          localStorage.setItem('channelData', JSON.stringify(result));
        });
      } else {
        console.error('Failed to follow/unfollow channel');
      }
    });
  }

  toggleOptionsDropdown() {
    this.showOptionsDropdown = !this.showOptionsDropdown;
  }

  addVideoToWatchList(vid_lib_id: any, video: any) {
    const userId = localStorage.getItem('userId');
    this.watchlistService.addInWatchList(userId, vid_lib_id).subscribe((result) => {
      video.isInWatchList = true;
      this.showSuccess('Video added to queue');
    });
  }

  removeVideoFromWatchList(vid_lib_id: any, video: any) {
    const userId = localStorage.getItem('userId');
    this.watchlistService.removeFromWatchList(userId, vid_lib_id).subscribe((result) => {
      video.isInWatchList = false;
      this.showSuccess('Video removed from queue');
      this.watchList = this.watchList.filter(item => item.vidLibId !== vid_lib_id);
      this.originalWatchList = this.originalWatchList.filter(item => item.vidLibId !== vid_lib_id);
      this.shuffledWatchList = this.shuffledWatchList.filter(item => item.vidLibId !== vid_lib_id);
      this.updateCurrentAndNextVideo();
    });
  }

  showSuccess(message: any) {
    this.toastrService.showNotification('success', '', message, 3000);
  }

  updateWatchHistory() {
    if (!this.currentVideoRunningTime || !this.videoDuration) return;
    const requestBody = {
      "channel": this.channelId,
      "isDrmVideo": "1",
      "playBackMode": 'server',
      "playState": "0",
      "secondsWatched": `${this.currentVideoRunningTime}`,
      "subtitleLanguage": "Stereo, 0.13 Mbps",
      "videoDuration": `${this.videoDuration}`,
      "videoFileSIze": `${this.videoFileSize}`,
      "videoId": this.vidLibId,
      "videoType": this.videoType,
      "createdOn": this.formatDateTime(),
      "eventId": "13",
      "eventType": '13',
      "userId": this.userId.toString()
    };
    this.mycontentService.updateUserVideoTracking(requestBody).subscribe(res => {
      console.log('Watch history updated');
    });
  }

  formatDateTime() {
    const currentDate = new Date();
    return currentDate.getDate() + '-' + currentDate.toLocaleString('default', { month: 'short' }) + '-' + currentDate.getFullYear() + ' ' + currentDate.getHours() + ':' + currentDate.getMinutes() + ':' + currentDate.getSeconds();
  }

  toggleDescription() {
    this.showFullDescription = !this.showFullDescription;
  }

  toggleAccordion() {
    this.showWatchList = !this.showWatchList;
  }

  async downloadFile(video: any) {
    this.downloadProgressService.resetDownloadItems();
    this.progressBarId = video?.vidLibId;
    this.downloadProgressService.currentDownloadVideoId = video.vidLibId;
    this.downloadProgressService.isDownloadInprogress = true;
    this.onDownloadClick(this.mediaUrl, video?.title);
  }

  onDownloadClick(manifestUri: string, title: string) {
    this.appComponent.setDownloadProgress(null, 0);
    this.downloadContent(manifestUri, title);
  }

  async downloadContent(manifestUri: string, title: string) {
    const metadata = {
      title: title,
      downloaded: new Date(),
      fileSize: this.videoDetails.videoFileSize,
      ...this.videoDetails
    };

    try {
      const thumbnailUrl = manifestUri.replace('drm_meta.mpd', 'thumb.jpg');
      const thumbnailBlob = await this.downloadProgressService.fetchThumbnailBlob(thumbnailUrl);
      metadata.thumbnail = thumbnailBlob;
      const storedContent = await window.storage.store(manifestUri, metadata);
      storedContent.isCompleted = true;
      this.downloadProgressService.prepareDownloadData(storedContent);
    } catch (err) {
      console.error("Error while storing:", err);
      this.downloadProgressService.resetDownloadItems();
    }
  }

  listContent() {
    return window.storage?.list();
  }

  async isDownloadFIleExist(originalManifestUri: string) {
    let isExist = false;
    const content = await this.listContent();
    for (const video of (content || [])) {
      if (video.originalManifestUri && video.originalManifestUri.includes(originalManifestUri)) {
        isExist = true;
        break;
      }
    }
    return isExist;
  }

  showReportTypes(video: any) {
    const dialogRef = this.dialog.open(ReportModalComponent, {
      panelClass: 'subscription-dialog',
      data: {
        vidLibId: video?.vidLibId
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Report dialog closed');
    });
  }

  openShareModal(video: any) {
    let videoLink = `${environment.baseUrl}cms/s/${video.vidLibId}`;
    const params: string[] = [];
    if (this.whitelabelService.isWhiteLabel()) {
      const channel = (this.whitelabelService.channel || '').replace('@', '');
      const entry = this.whitelabelService.entryType || 'f';
      params.push(`c=${channel}`, `e=${entry}`);
    }
    const basePath = getAppBasePath();
    if (basePath) {
      params.push(`p=${encodeURIComponent(basePath)}`);
    }
    if (params.length) {
      videoLink += '?' + params.join('&');
    }
    if (navigator.share) {
      navigator.share({
        title: video?.title || 'Check out this video',
        url: videoLink
      }).catch(() => {});
    } else {
      this.dialog.open(ShareModalComponent, {
        data: { videoLink },
      });
    }
  }

  isBottomSheetOpen = false;

  openBottomSheet() {
    this.isBottomSheetOpen = true;
    document.body.style.overflow = 'hidden';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isBottomSheetOpen) {
      this.closeBottomSheet();
    }
  }

  getVideoTags(): string[] {
    if (!this.videoDetails?.tags) return [];
    return this.videoDetails.tags.split(',').map(tag => tag.trim());
  }

  getDescriptionWithLinks(description: string): string {
    if (!description) return '';
    
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    let result = description.replace(urlRegex, (url) => {
      const displayUrl = url.length > 30 ? url.substring(0, 30) + '...' : url;
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" title="${url}" class="description-link">${displayUrl}</a>`;
    });
    
    const hashtagRegex = /#(\w+)/g;
    result = result.replace(hashtagRegex, (hashtag, tag) => {
      return `<span class="description-hashtag" onclick="angular.getComponent(this).onHashtagClick('${tag}')">${hashtag}</span>`;
    });
    
    return result;
  }
  
  onHashtagClick(tag: string) {
    console.log('Hashtag clicked:', tag);
  }

  ngAfterViewInit() {
    this.setupTouchGestures();
    this.setupMobileQueueTouchGestures();
  }
  
  private startY = 0;
  private currentY = 0;
  private isDragging = false;
  private initialScrollTop = 0;

  
  private setupTouchGestures() {
    setTimeout(() => {
      const bottomSheet = document.querySelector('.bottom-sheet') as HTMLElement;
      const scrollableContent = document.querySelector('.bottom-sheet-content') as HTMLElement;
      if (bottomSheet && scrollableContent) {
        bottomSheet.addEventListener('touchstart', (e: TouchEvent) => {
          this.startY = e.touches[0].clientY;
          this.isDragging = true;
          this.initialScrollTop = scrollableContent.scrollTop;
          bottomSheet.style.transition = 'none';
        });
        bottomSheet.addEventListener('touchmove', (e: TouchEvent) => {
          if (!this.isDragging) return;
          this.currentY = e.touches[0].clientY;
          const deltaY = this.currentY - this.startY;
          if (deltaY > 0 && scrollableContent.scrollTop === 0) {
            bottomSheet.style.transform = `translateY(${deltaY}px)`;
            e.preventDefault();
          }
        });
        bottomSheet.addEventListener('touchend', () => {
          if (!this.isDragging) return;
          this.isDragging = false;
          bottomSheet.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          const deltaY = this.currentY - this.startY;
          if (deltaY > 200 && scrollableContent.scrollTop === 0) {
            this.closeBottomSheet();
          } else {
            bottomSheet.style.transform = 'translateY(0)';
          }
        });
      }
    }, 100);
  }
  
  closeBottomSheet() {
    this.isBottomSheetOpen = false;
    document.body.style.overflow = 'auto';
    
    setTimeout(() => {
      const bottomSheet = document.querySelector('.bottom-sheet') as HTMLElement;
      if (bottomSheet) {
        bottomSheet.style.transform = '';
        bottomSheet.style.transition = '';
      }
    }, 300);
  }

  isMobileQueueOpen = false;

  openMobileQueue() {
    this.isMobileQueueOpen = true;
    document.body.style.overflow = 'hidden';
  }

  private queueStartY = 0; 
  private queueCurrentY = 0;
  private queueIsDragging = false;
  private queueInitialScrollTop = 0;

  private setupMobileQueueTouchGestures() {
    setTimeout(() => {
      const queueSheet = document.querySelector('.mobile-queue-sheet') as HTMLElement;
      const scrollableContent = document.querySelector('.mobile-queue-content') as HTMLElement; 
      if (queueSheet && scrollableContent) {
        queueSheet.addEventListener('touchstart', (e: TouchEvent) => {
          this.queueStartY = e.touches[0].clientY;
          this.queueIsDragging = true;
          this.queueInitialScrollTop = scrollableContent.scrollTop;
          queueSheet.style.transition = 'none';
        });
        queueSheet.addEventListener('touchmove', (e: TouchEvent) => {
          if (!this.queueIsDragging) return;
          this.queueCurrentY = e.touches[0].clientY;
          const deltaY = this.queueCurrentY - this.queueStartY;
          if (deltaY > 0 && scrollableContent.scrollTop === 0) {
            queueSheet.style.transform = `translateY(${deltaY}px)`;
            e.preventDefault();
          }
        });
        queueSheet.addEventListener('touchend', () => {
          if (!this.queueIsDragging) return;
          this.queueIsDragging = false;
          queueSheet.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          const deltaY = this.queueCurrentY - this.queueStartY;
          if (deltaY > 200 && scrollableContent.scrollTop === 0) {
            this.closeMobileQueue();
          } else {
            queueSheet.style.transform = 'translateY(0)';
          }
        });
      }
    }, 100);
  }

  closeMobileQueue() {
    this.isMobileQueueOpen = false;
    document.body.style.overflow = 'auto';
    
    setTimeout(() => {
      const queueSheet = document.querySelector('.mobile-queue-sheet') as HTMLElement;
      if (queueSheet) {
        queueSheet.style.transform = '';
        queueSheet.style.transition = '';
      }
    }, 300);
  }

  @HostListener('document:touchmove', ['$event'])
  handleTouchMove(event: TouchEvent) {
    if (this.isMobileQueueOpen) {
      const queueSheet = document.querySelector('.mobile-queue-sheet');
      if (queueSheet && !queueSheet.contains(event.target as Node)) {
        event.preventDefault();
      }
    } else if (this.isBottomSheetOpen) {
      const bottomSheet = document.querySelector('.bottom-sheet');
      if (bottomSheet && !bottomSheet.contains(event.target as Node)) {
        event.preventDefault();
      }
   }
  }

  getChannelInitial(video: any): string {
    const desc = video?.channel_desc?.trim() || '';
    const cleaned = desc.startsWith('@') ? desc.slice(1) : desc;
    for (let char of cleaned) {
      if (/[a-zA-Z0-9]/.test(char)) {
        return char.toUpperCase();
      }
    }
    return '?'; 
  }

  userChannel(channel){
    const route = this.whitelabelService.getPrefixedRoute('channel', 'user');
    console.log(route)
    this.router.navigate([route], {
      queryParams: {
        channelId: channel.channelId,
        category: 'CC_PRIME'
      }
    });
  }

  inIos:boolean = false;
  checkIOSView(){
    const win = window as any;
    if ( win.webkit && win.webkit.messageHandlers && win.webkit.messageHandlers.iosVideoPlayer ) {
      this.inIos = true;
    }
  }

  // getAspectRatio(video: any): string {
  //   if (!video.aspectRatio) return '16 / 9';
  //   const parts = video.aspectRatio.split(',');
  //   if (parts.length < 3) return '16 / 9';
  //   const width = parseInt(parts[0], 10);
  //   const height = parseInt(parts[1], 10);
  //   const orientation = parts[2];
  //   if (orientation === 'V' && width > 0 && height > 0) {
  //     return `${width} / ${height}`; 
  //   }
  //   return '16 / 9'; 
  // }

  getAspectRatio(video: any): string {
    // if (window.innerWidth >= 768) {
    //   return '16 / 9';
    // }
    // if (!video?.aspectRatio) return '16 / 9';
    // const parts = video?.aspectRatio.split(',');
    // if (parts.length < 3) return '16 / 9';
    // const width = parseInt(parts[0], 10);
    // const height = parseInt(parts[1], 10);
    // const orientation = parts[2];
    // if (orientation === 'V' && width > 0 && height > 0) {
    //   return `${width} / ${height}`; 
    // }
    return '16 / 9';
  }
  
}